import { styled } from 'styled-components';

// These are the styles for the "Edit Columns" popup
export const PlayFinderColumnsLayout = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;

  // adjustment for search input
  .ui.input {
    width: 100%;
    height: 36px;

    > i.icon {
      top: 4px;
    }
  }

  .row {
    display: flex;
    flex-direction: row;
    margin: -1rem -1rem -1rem 0;
    height: 40vh;

    // left column: parent categories
    > div:first-child {
      width: 360px;
      padding: ${({ theme }) => theme.sizing.medium} 0 0 0;
      overflow-y: auto;

      .inputCheck {
        padding: ${({ theme }) => theme.sizing.tiny}
          ${({ theme }) => theme.sizing.small}
          ${({ theme }) => theme.sizing.small};
      }

      h4 {
        margin-top: ${({ theme }) => theme.sizing.small};
        margin-bottom: ${({ theme }) => theme.sizing.tiny};
      }
    }

    // right column: child categories
    > div:last-child {
      flex: 1;
      padding: 0 ${({ theme }) => theme.sizing.medium};
      width: 290px;
      height: 100%;
      background-color: ${({ theme }) => theme.colours.canvas.secondary.main};
      overflow-y: auto;

      h3 {
        ${({ theme }) => theme.typography.headingRegular};
        margin-bottom: ${({ theme }) => theme.sizing.medium};
      }

      h4 {
        ${({ theme }) => theme.typography.headingSmall};
        color: ${({ theme }) => `${theme.colours.ink.primary.main}60`};
        margin-bottom: ${({ theme }) => theme.sizing.small};
      }
    }
  }
`;
PlayFinderColumnsLayout.displayName = 'PlayFinderColumnsLayout';

export const PlayFinderColumnStyle = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
  height: 32px;
  display: flex;
  margin-bottom: ${({ theme }) => theme.sizing.small};
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.tertiary};
  padding: 0 ${({ theme }) => theme.sizing.small};
  gap: ${({ theme }) => theme.sizing.small};

  span:first-child {
    cursor: grab;
  }

  span:nth-child(2) {
    flex-grow: 2;
  }
`;
PlayFinderColumnStyle.displayName = 'PlayFinderColumnStyle';

export const PlayFinderColumnsDragHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${({ theme }) => theme.sizing.medium} 0 0 0;
  align-items: flex-start;
`;
PlayFinderColumnsDragHeader.displayName = 'PlayFinderColumnsDragHeader';
